import styled from "styled-components";

export const SideBarWrapper = styled.div`
  width: 310px;
  height: 100vh;
  flex-shrink: 0;

  background: linear-gradient(0deg, #373636 0%, #373636 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  > .header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 50px 30px 66px 30px;
    width: calc(100% - 60px);
    height: 36.922px;
    > img {
      width: 158.381px;
      height: 36.922px;
      cursor: pointer;
    }
  }

  > .body {
    width: 100%;
    flex: 1;
    margin-bottom: 40px;

    display: flex;
    flex-direction: column;
    gap: 5px;
    position: relative;
    position: relative;
    > .item {
      cursor: pointer;
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      > .child {
        position: absolute;
        height: 50px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 15px;
        top: 40px;
        left: 103px;

        > .item {
          font-size: 20px;
          font-weight: 400;
          color: #fff;
          font-family: Pretendard;
        }
      }

      > .icon-back {
        margin-left: 34px;
        width: 44px;
        height: 44px;
        border-radius: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        > img {
          width: 20px;
          height: 20px;
        }
      }

      > .icon-back.true {
        background-color: white;
      }

      > .line {
        width: 4px;
        height: 44px;
      }

      > .line.true {
        background: #fff;
      }

      > .title {
        margin-left: 20px;
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.4px;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        padding-right: 30px;
      }
    }

    > .child {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 10px;
      margin-bottom: 15px;
      margin-left: 100px;
      cursor: pointer;

      > .item {
        font-size: 20px;
        font-weight: 400;
        color: #fff;
        font-family: Pretendard;
      }
    }
  }

  > .log-out {
    cursor: pointer;
    width: 100%;
    text-align: center;
    color: #9c9c9c;
    text-align: center;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 34px;
  }

  > .footer {
    margin-bottom: 33px;
    width: 250px;
    height: 250px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    padding: 30px 25px 21px 25px;
    border-radius: 15px;
    background:
      linear-gradient(0deg, #5f5e5e 0%, #5f5e5e 100%),
      linear-gradient(82deg, #313860 2.25%, #151928 79.87%), #5f5e5e;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    justify-content: space-between;
    > .title {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.5px;
      > .diff-date {
        margin-top: 5px;
        color: #fff;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px;
        letter-spacing: -0.36px;
      }
    }

    > .description {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.3px;
    }

    > .button {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      height: 50px;
      border-radius: 15px;
      background: #6436e7;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.4px;
    }
  }

  > .premium {
    justify-content: center;
    background: linear-gradient(
      136.93deg,
      rgba(247, 230, 89, 0.5) 1.58%,
      rgba(255, 255, 255, 0.5) 45.64%,
      rgba(231, 208, 53, 0.5) 98.42%
    );
  }
`;
